import * as addressActionCreators from 'store/actionCreators/addresses';

import { addressSource } from 'sources';
import { setError } from 'store/actions/app';
import { AppThunk } from 'store/store';

// eslint-disable-next-line import/prefer-default-export
export const fetchAddress = (id: string): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    const address = await addressSource.Fetch(id);
    dispatch(addressActionCreators.fetchSuccess(address));
  } catch (e) {
    dispatch(setError(e?.message));
  }
};
